import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-brand">QuitStick</div>
      <div className="footer-tagline">
        A behavioral tool for smokers ready to take the first step.
      </div>
      <div className="footer-links">
        <Link to="/shipping-policy" className="footer-link">Shipping Policy</Link>
        <Link to="/contact" className="footer-link">Contact Us</Link>
        <Link to="/pricing" className="footer-link">Pricing</Link>
        <Link to="/terms" className="footer-link">Terms & Conditions</Link>
        <Link to="/privacy" className="footer-link">Privacy Policy</Link>
        <Link to="/refunds" className="footer-link">Refunds</Link>
      </div>
      <div className="footer-copyright">
        Made in India · © 2025 QuitStick
      </div>
    </footer>
  );
};

export default Footer;
